module.exports = __webpack_public_path__ + "static/StaticCandyBanner-a36797e8f6703a48f49fc4a6d6ce59ff.jpeg";